module.exports = __webpack_public_path__ + "static/media/plano_arica.7d908743.png";